// src/config.ts
export const API_URL = "https://api.navaroute.dev/api";
